import { produce } from "immer";

export const actions = (set, get) => ({
    setSelectedOfficeListSearch: (selectedOfficeListSearch) => set(produce(state => {
        const moduleState = state[get().selectedModule]?.search;
        if (!moduleState) return;
        state[get().selectedModule].search.selectedOfficeListSearch = selectedOfficeListSearch
    }), false, 'setSelectedOfficeListSearch'),
});
